<template>

    <v-layout col justify-start>
      <v-flex xs10 mx-0>
        <v-autocomplete  v-model="placeWork.select" :items="placeWork.places" item-text="pn" item-value="id"
          :label="prompt" :auto-select-first='true' v-focus autofocus
          :search-input.sync="placeSearch" :loading="placeWork.loading"   return-object  @change="placeChange()">     
        </v-autocomplete>
        <v-layout row v-if="place.extra">
          <v-flex xs10>
              <v-text-field v-model="place.extra" label="Street/Locality"/>
          </v-flex>
          <v-flex xs2>
              <v-icon  small  @click='delPlaceExtra()' >delete</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon v-if="!suppressDelete" small  @click='delPlace()'>delete</v-icon>
        <v-icon v-if="(!place.extra && !suppressPlaceExtra)"  small  @click='addPlaceExtra()'>place</v-icon>
      </v-flex>
    </v-layout>    

</template>        

<script>

export default {

  components: {  },
  props: {
    place: null,
    prompt: null,
    container: null,
    containerProp: null,
    suppressPlaceExtra: false,
    suppressDelete: false
  },

  data () {
    return {
      addSeqForRid: -1,
      placeWork: {
        select: {id: -1, pn: ""}, 
        places: [],
        loading: false,
        origId: -1,
        placeRelType: null,
        pendingSearch: null
      },
      placeSearch: null  
    }
  },

  watch: {

    async placeSearch (val) {
      if (val && val !== this.placeWork.select.pn && (val.length >= 2)) 
        this.error = await this.$placeQuerySelections(val, this.placeWork) ;      
    }
    /*
    place: function (oldVal, newVal) {
      console.log("- - - - - - ^^^^^EditPLACE place prop CHANGED from " + JSON.stringify(oldVal) + " to " + JSON.stringify(newVal)) ;
      if (newVal === null) {
        console.log("  EDITPLACE NEW IS NULL!") ;
        if (this.container && this.containerProp) {
          console.log("EDITPLACE Adding empty place type " + this.containerProp + " to container " + JSON.stringify(this.container)) ;
          this.containerProp[this.container] = {"rid":-1, "town": {"id":-1, "v":null}, "state": {"id": -1, "v":null}, "country": {"id": -1, "v":null}}
        }
      }
    }
    */
  },

  async created () {
    // console.log("IIIIIIIn editPlace place= " + JSON.stringify(this.place)) ;
    /*
    if (!this.place) {
      if (this.container && this.containerProp) {
        console.log("Adding empty place type " + this.containerProp + " to container " + JSON.stringify(this.container)) ;
        this.container.xyz.abc = this.container.bollocks.id ;
        this.containerProp[this.container] = {"rid":-1, "town": {"id":-1, "v":null}, "state": {"id": -1, "v":null}, "country": {"id": -1, "v":null}}
      }
    }
    */
    this.$updatePlaceSelectionFromRecord(this.placeWork, this.place) ;
  },

  methods: {

    placeChange () {
      console.log("---------------------------------placeChange: " + JSON.stringify(this.placeWork.select)) ;
      this.place.newId = this.placeWork.select.id ;
    },

    addPlaceExtra () {

      this.place.extra = " " ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    delPlaceExtra () {

      delete this.place.extra ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    delPlace () {
      this.place.newId = -1 ;
      this.placeWork.select.id = -1 ;
      this.placeWork.select.pn = "*DELETED*" ;
      this.placeWork.places = [{id:-1, pn:"*DELETED*"}] ;
    }
  } 
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Person/EditPlace.vue